import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatDialogConfig, MatDialog } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { CategoryService } from '../../_ecomservices/category.service';
import { CategoryEditComponent } from '../category-edit/category-edit.component';
import { CategoryCreateComponent } from '../category-create/category-create.component';
import { DialogService } from 'src/app/_services/dialog.service';


@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit {

  categoryList: any = [];
  displayedColumns: string[] = ['CategoryName', 'ParentCategory', 'ChildCategory', 'Description', 'Action'];

  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  searchKey: string;

  constructor(
    private titleService: Title,
    private dialogService: DialogService,
    public categoryService: CategoryService,
    private loading: LoadingService,
    private notificationService: NotificationService,
    private dialog: MatDialog,) { }

  ngOnInit() {
    this.titleService.setTitle('Category List');
    this.onLoadCategories();
  }

  onLoadCategories() {
    var result = this.categoryService.get_all_categories().subscribe(data => {
      console.log(data);
      this.dataSource = new MatTableDataSource<any>(data['categoryList']);
      this.dataSource.paginator = this.paginator;
      this.loading.spin$.next(false);
    });
  }

  applyFilter() {
    this.dataSource.filter = this.searchKey.trim().toLocaleLowerCase();
  }

  onSearchClear() {
    this.searchKey = "";
    this.applyFilter();
  }

  toggleCatStatusChange(event: any, categoryId) {
    let checked = event.checked;
    let status = 0;
    if (checked) {
      status = 1;
    }
    this.categoryService.update_category_status(categoryId, status).subscribe(data => {
      // console.log(data);
    });
  }

  onCreateCategory() {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '0px' };
    this.dialog.open(CategoryCreateComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.onLoadCategories();
    });
  }

  onEdit(categoryId) {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '0px' };
    matDialogConfig.data = { categoryId: categoryId }
    this.dialog.open(CategoryEditComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.onLoadCategories();
    });
  }

  onDelete(categoryId) {
    console.log(categoryId);
    this.dialogService.openConfirmDialog('Are you sure want to deleted?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.loading.spin$.next(true);
          this.categoryService.delete_category(categoryId).subscribe(data => {
            console.log(data);
            if (data['status']) {
              this.notificationService.success(data['message']);
              this.onLoadCategories();
              this.loading.spin$.next(false);
            }
            else {
              this.notificationService.error(data['error_message']);
              this.loading.spin$.next(false);
            }
          });
        }
      });
  }



}
